module.exports = __webpack_public_path__ + "img/count_down_block_start.24a70b7d.png";